module.exports = __webpack_public_path__ + "media/images/socials/tiktok-eb3d45dae5fd8df2980990a8553e9a84.png";